import React from 'react';
import NameCellWrapper from './NameCellWrapper';
import CellIcon from './CellIcon';
import SystemFlag from '../SystemFlag';

const NameCell = ({
  className,
  disabled,
  href,
  icon,
  iconColour,
  link,
  loading,
  message,
  name,
  onClick,
  system,
  renderSystemFlag = () => <SystemFlag />,
}) => (
  <NameCellWrapper name={name} disabled={disabled} className={className} link={link} href={href} onClick={onClick}>
    {icon && (<CellIcon name={icon} colour={iconColour} loading={loading} message={message} />)}
    {name}
    {system && renderSystemFlag()}
  </NameCellWrapper>
);

export default NameCell;
